export default "__VITE_ASSET__CVLa9Smc__"